import React from "react";
import { compose, withApollo } from "react-apollo";
import { connect } from "react-redux";
import { AssignGroupContext } from "./context";
import AssignGroupTopBar from "../components/AssignGroupTopBar";

const TopBar = ({ setSearchGroup }) => {
  return (
    <AssignGroupTopBar
      setSearchGroup={setSearchGroup}
      groupContext={AssignGroupContext}
      searchLabel="Search for booking group, equipment"
      searchSize="325px"
    />
  );
};

export default compose(connect(null), withApollo)(TopBar);
